import api from '../services/api';

/**
 * Save one student's mark on a lesson. A status records it (/attendance/mark);
 * no status clears it back to "not marked" (/attendance/clear), which also
 * un-bills a sport session or a private lesson the mark had charged.
 */
export function saveAttendance({ lessonId, studentId, status, ...extra }) {
  if (!status) return api.post('/attendance/clear', { lessonId, studentId });
  return api.post('/attendance/mark', { lessonId, studentId, status, ...extra });
}
